import "babel-polyfill";
import initBoard from './initBoard';
import initControlPanel from './initControlPanel';
import setupManualControl from './manual-control';

initBoard();
initControlPanel();
setupManualControl();